'use client'

export default function DealsStatusBanners({
  isOffline,
  showInstallBanner, installPrompt, setInstallPrompt, setShowInstallBanner,
  showSubscribedBanner, setShowSubscribedBanner,
  currentUser, setShowModal,
  isPaid, dealTypeTab, notifPermission, requestPushPermission,
}) {
  return (
    <>
      {isOffline && (
        <div className="mb-5 flex items-center gap-2 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
          <span className="text-amber-500 text-base" aria-hidden="true">📡</span>
          <p className="text-sm font-medium text-amber-800">Offline — showing cached deals</p>
        </div>
      )}
      {showInstallBanner && (
        <div className="mb-5 rounded-xl border border-blue-200 bg-gradient-to-r from-blue-50 to-violet-50 px-4 py-3 shadow-sm">
          <div className="flex items-center gap-3">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src="/icon.svg" alt="" width={40} height={40} className="shrink-0 rounded-xl shadow-sm" />
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-gray-900">Add FairFares to your homescreen</p>
              <p className="text-xs text-gray-500">Browse deals faster, works offline too</p>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <button
                onClick={async () => {
                  if (!installPrompt) return
                  installPrompt.prompt()
                  const { outcome } = await installPrompt.userChoice
                  setInstallPrompt(null)
                  setShowInstallBanner(false)
                  if (outcome === 'accepted') {
                    localStorage.setItem('ff_pwa', '1')
                    window.plausible?.('PWAInstall', { props: { outcome: 'accepted' } })
                  } else {
                    window.plausible?.('PWAInstall', { props: { outcome: 'dismissed' } })
                  }
                }}
                className="rounded-lg bg-blue-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-blue-700 transition-colors"
              >
                Install
              </button>
              <button
                onClick={() => { setShowInstallBanner(false); window.plausible?.('PWAInstall', { props: { outcome: 'banner_closed' } }) }}
                className="text-gray-500 text-xs hover:text-gray-700"
                aria-label="Dismiss"
              >
                ✕
              </button>
            </div>
          </div>
        </div>
      )}
      {showSubscribedBanner && (
        <div className="mb-5 flex items-center justify-between gap-3 rounded-xl border border-green-200 bg-green-50 px-4 py-3">
          <p className="text-sm text-green-800">
            <span className="font-semibold">✅ You&apos;re subscribed!</span> We&apos;ll email you the next time deals appear from your airport.
          </p>
          <button
            onClick={() => setShowSubscribedBanner(false)}
            className="shrink-0 text-green-400 text-xs hover:text-green-600"
            aria-label="Dismiss"
          >
            ✕
          </button>
        </div>
      )}
      {isPaid && dealTypeTab === 'red' && notifPermission !== 'granted' && (
        <div className="mb-5 flex items-center justify-between gap-3 rounded-xl border border-red-200 bg-gradient-to-r from-red-50 to-orange-50 px-4 py-3">
          <div className="min-w-0">
            <p className="text-sm font-semibold text-red-800">⚡ Get instant error fare alerts</p>
            <p className="text-xs text-red-600 mt-0.5">Error fares disappear fast — enable push notifications to be first.</p>
          </div>
          {notifPermission === 'denied' ? (
            <span className="shrink-0 text-xs text-gray-500">Blocked in browser</span>
          ) : (
            <button
              onClick={requestPushPermission}
              className="shrink-0 rounded-lg bg-red-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-red-700 transition-colors"
            >
              Enable
            </button>
          )}
        </div>
      )}
    </>
  )
}
